import { combineEpics } from 'redux-observable';

import createWatchListEntryEpic$ from './createWatchListEntryEpic';
import updateWatchListEntryEpic$ from './updateWatchListEntryEpic';

export default combineEpics(
  createWatchListEntryEpic$,
  updateWatchListEntryEpic$,
);


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/epics/index.js